import React from 'react'
import PropTypes from 'prop-types'
import {
	Card,
	Text,
	Heading,
	Box,
	Circle,
	chakra,
	Image,
} from '@chakra-ui/react'
import SVGIcon from '../../../assets/svgIcons'

const RenderOrgCard = props => {
	const {
		cardColor,
		imgSrc,
		OrgName,
		empDesignation,
		NoofNotifications,
		onClick,
	} = props
	return (
		<Card
			minW='15.625rem'
			h='25rem'
			bg={cardColor}
			color='white'
			flexDirection='column'
			alignItems='center'
			justifyContent='space-evenly'
			m='1.56rem'
			boxShadow='0px 2px 4px rgba(0, 0, 0, 0.25)'
			borderRadius='10px'
			cursor='pointer'
			onClick={() => onClick(props)}
			_first={{ marginLeft: 'auto' }}
			_last={{ marginRight: 'auto' }}
		>
			{/* <Image
				src={imgSrc}
				fallbackSrc={defaultOrgIcon}
				maxW='10rem'
				maxH='10rem'
				alt='Org Card image'
				filter='brightness(0) invert(1)'
			/> */}
			{!!imgSrc?
        <Image
          src={imgSrc}
          maxW="10rem"
          maxH="10rem"
		  alt='Org Card image'
          filter="brightness(0) invert(1)"
        />
        :
        <SVGIcon
            iconName='OrgCardGreneLogoSvg'
            svgProps={{
              width: '64',
              height: '60',
              viewBox: '0 0 64 60',
            }}
            // pathProps={{ fill: '#009B76' }}
          />
        }
			<Box textAlign='center'>
				<Heading size='md' color='white' align='center' as='b'>
					{OrgName}
				</Heading>
				<Text className='description' fontSize='sm' color='white' opacity='0.8'>
					{empDesignation}
				</Text>
			</Box>
			<Box>
				<Box display='inline-block' pr={2}>
					<Circle
						fontWeight='900'
						fontSize='1.125rem'
						bg='#FFDE55'
						color='black'
						size='1.875rem'
					>
						{NoofNotifications}
					</Circle>
				</Box>
				<chakra.span opacity='0.8'>Notifications</chakra.span>
			</Box>
		</Card>
	)
}

RenderOrgCard.propType = {
	imgSrc: PropTypes.string,
	cardColor: PropTypes.string,
	OrgName: PropTypes.string,
	empDesignation: PropTypes.string,
	NoofNotifications: PropTypes.number.isRequired,
	onClick: PropTypes.func,
}

export { RenderOrgCard }
